import { render, staticRenderFns } from "./TemplateDebts.vue?vue&type=template&id=2fbd66a4&scoped=true&"
import script from "./TemplateDebts.vue?vue&type=script&lang=js&"
export * from "./TemplateDebts.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDebts.vue?vue&type=style&index=0&id=2fbd66a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbd66a4",
  null
  
)

export default component.exports